import React from 'react'
import styled, { useTheme } from 'styled-components'
import { getChainScanLink, getScanNameByChainId } from '@mprolab/sdk'
import { ExternalLink } from 'react-feather'
import { Flex, Text, TextVariant } from '@mprolab/uikit'

const FooterWrapper = styled(Flex)`
  align-items: center;
  width: 100%;
  justify-content: center;
  border-top: 1px solid #272e39;
`

const LinkWrapper = styled(Flex)`
  cursor: pointer;
  align-items: center;
  margin-top: 24px;
`

interface ChainScanFooterProps {
  chainId: number
  transactionHash: string
  type?: 'transaction' | 'token' | 'address'
  testId?: string
}

const ChainScanFooter: React.FC<ChainScanFooterProps> = ({
  chainId,
  transactionHash,
  type = 'transaction',
  testId
}) => {
  const theme = useTheme()

  return (
    <FooterWrapper>
      <LinkWrapper
        onClick={() => window.open(getChainScanLink({ chainId, data: transactionHash, type }), '_blank')}
        data-testid={testId}
      >
        <Text variant={TextVariant.BODY_DEFAULT_BOLD} mr="8px" clickable>
          {getScanNameByChainId(chainId)}
        </Text>
        <ExternalLink color={theme.colors.purple} />
      </LinkWrapper>
    </FooterWrapper>
  )
}

export default ChainScanFooter
